

























































































































































































































import { Component, Watch } from "vue-property-decorator";
import { WorkerWizardModule } from "@/store/modules/workerWizard";
import GiganautVueForm from "@/components/Shared/GiganautVueForm";
import ListUtils from '@/lib/listUtils';
import CountryIso from "@/lib/countryIso";
import AddressUtils from "@/lib/addressUtils";
import IFullAddress from "@/models/Shared/IFullAddress";
import ajax from "@/lib/ajax";

@Component({
  name: "WorkerWizardAddress",
  components: { },
})
export default class WorkerWizardAddress extends GiganautVueForm {

  country: CountryIso = new CountryIso();
  addressSearchText = '';
  geocodingInProgress = false;

  // Re-validate form when work type changes (user may go back and add/remove TEMP)
  @Watch('isTempWorker')
  onWorkTypeChanged() {
    this.$nextTick(() => {
      if (this.$refs.form) {
        (this.$refs.form as any).resetValidation();
      }
    });
  }

  async validateForm() {
    this.addressSearchText = '';
    return !(this.$refs.form as any).validate();
  }

  async getAddressData(addressData: any, placeData: any) {
    const address = WorkerWizardModule.newWorker.worker as IFullAddress
    AddressUtils.populateGoogleMapsAddressData(addressData, placeData, address)
    // Mark as exact geo since user selected from Google autocomplete
    this.worker.isExactGeo = true;
  }

  async lookupCoordinates() {
    if (!this.hasAddressData) return;

    this.geocodingInProgress = true;

    try {
      const params = new URLSearchParams();
      if (this.worker.buildingNameNumber) params.append('buildingNameNumber', this.worker.buildingNameNumber);
      if (this.worker.streetRoadBlock) params.append('streetRoadBlock', this.worker.streetRoadBlock);
      if (this.worker.locality) params.append('locality', this.worker.locality);
      if (this.worker.cityTown) params.append('cityTown', this.worker.cityTown);
      if (this.worker.stateProvinceRegion) params.append('stateProvinceRegion', this.worker.stateProvinceRegion);
      if (this.worker.postZipCode) params.append('postZipCode', this.worker.postZipCode);
      if (this.worker.countryCode) params.append('countryCode', this.worker.countryCode);

      const response = await ajax.get(`/api/v1/agency/address/lookup-geo?${params.toString()}`);

      this.worker.geometry.lat = response.data.lat;
      this.worker.geometry.lng = response.data.lng;
      this.worker.isExactGeo = response.data.isExactGeo;
    } catch (error) {
      console.error('Geocoding error:', error);
    } finally {
      this.geocodingInProgress = false;
    }
  }

  get worker() {
    return WorkerWizardModule.newWorker.worker;
  }

  get isoCountries() {
    return ListUtils.countries();
  }

  get loading() {
    return WorkerWizardModule.loading;
  }

  get hasCoordinates() {
    return this.worker.geometry.lat !== 0 || this.worker.geometry.lng !== 0;
  }

  get hasAddressData() {
    return !!(
      this.worker.buildingNameNumber ||
      this.worker.streetRoadBlock ||
      this.worker.locality ||
      this.worker.cityTown ||
      this.worker.stateProvinceRegion ||
      this.worker.postZipCode
    );
  }

  get mapCenter() {
    return {
      lat: Number(this.worker.geometry.lat) || 0,
      lng: Number(this.worker.geometry.lng) || 0
    };
  }

  get isTempWorker(): boolean {
    return this.worker.workTypes && this.worker.workTypes.includes('Temp');
  }

  get buildingNameNumberValidation(): string {
    return this.isTempWorker ? this.FieldValidationCodes.BuildingNameNumberRequired : this.FieldValidationCodes.BuildingNameNumber;
  }

  get streetRoadBlockValidation(): string {
    return this.isTempWorker ? this.FieldValidationCodes.StreetRoadBlockRequired : this.FieldValidationCodes.StreetRoadBlock;
  }

  get postZipCodeValidation(): string {
    return this.isTempWorker ? this.FieldValidationCodes.PostZipCodeRequired : this.FieldValidationCodes.PostZipCode;
  }
}
